import { useEffect, useMemo, useRef, useState } from "react";
import { History } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

export function BuyerInput({ value, onChange, testId, className = "", ...rest }) {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  useEffect(() => { api.get("/transactions/destinations").then((r) => setList(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const h = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  const q = (value || "").trim().toLowerCase();
  const matches = useMemo(() => list.filter((b) => !q || b.name.toLowerCase().includes(q)).filter((b) => b.name.toLowerCase() !== q).slice(0, 8), [list, q]);

  return (
    <div className="relative" ref={box}>
      <Input value={value} onChange={(e) => { onChange(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} autoComplete="off" className={className} data-testid={testId} {...rest} />
      {open && matches.length > 0 && (
        <ul className="absolute z-50 mt-1 w-full max-h-60 overflow-y-auto rounded-lg border border-slate-200 bg-white shadow-lg py-1" data-testid={`${testId}-suggestions`}>
          <li className="px-3 py-1 text-[10px] font-semibold uppercase tracking-wider text-slate-400 flex items-center gap-1"><History className="h-3 w-3" /> Pembeli sebelumnya</li>
          {matches.map((b, i) => (
            <li key={b.name}>
              <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => { onChange(b.name); setOpen(false); }}
                className="w-full text-left px-3 py-1.5 text-sm hover:bg-sky-50 flex items-center justify-between gap-2 transition-colors" data-testid={`${testId}-option-${i}`}>
                <span className="truncate text-slate-800">{b.name}</span><span className="text-[10px] text-slate-400 shrink-0">{b.count}×</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
